import React from 'react';
import { AccountingLedgerSource } from '../../../api/types';
import LedgerDatasetTableShell, { LedgerDatasetTableShellProps } from '../shared/LedgerDatasetTableShell';

type AccountingDatasetTableProps = Omit<LedgerDatasetTableShellProps, 'view' | 'accountingSource'> & {
    accountingSource: Exclude<AccountingLedgerSource, 'ar_customers' | 'ar_ledger' | 'ap_vendors' | 'ap_ledger'>;
};

const AccountingDatasetTable: React.FC<AccountingDatasetTableProps> = ({ accountingSource, ...props }) => (
    <LedgerDatasetTableShell {...props} view="accounting" accountingSource={accountingSource} />
);

export default AccountingDatasetTable;
